// src/pages/ContractsPage.js
import React, { useState } from 'react';
import ContractTemplates from '../components/contracts/ContractTemplates';
import ContractsManager from '../components/contracts/ContractsManager';
import VisualBuilder from '../components/prescriptions/VisualBuilder';

export default function ContractsPage() {
  const [tab, setTab] = useState('contracts'); // 'templates' | 'contracts' | 'visual'

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">Contratos</h1>

      <div className="mb-4 border-b">
        <nav className="-mb-px flex gap-4">
          <button
            className={`px-3 pb-2 border-b-2 ${tab==='contracts' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-600'}`}
            onClick={()=>setTab('contracts')}
          >
            Contratos
          </button>
          <button
            className={`px-3 pb-2 border-b-2 ${tab==='templates' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-600'}`}
            onClick={()=>setTab('templates')}
          >
            Templates
          </button>
          <button
            className={`px-3 pb-2 border-b-2 ${tab==='visual' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-600'}`}
            onClick={()=>setTab('visual')}
          >
            Visual
          </button>
        </nav>
      </div>

      {tab === 'contracts' && <ContractsManager />}
      {tab === 'templates' && <ContractTemplates />}
      {tab === 'visual' && <VisualBuilder />}
    </div>
  );
}